'use strict';

import {DOM} from './DOM.js';
export class Notifications {
	#type = '';
	#message = '';
	#timeout = 2000;

	setType(type) {
		this.#type = type;
		return this;
	}

	setMessage(message) {
		this.#message = message;
		return this;
	}

	setTimeout(timeout) {
		this.#timeout = timeout;
		return this;
	}

	execPopup() {
		const notification = document.createElement('div');
		notification.classList.add('levcharity-notification-popup', this.#type);
		notification.textContent = this.#message;
		notification.style.setProperty('--progress-duration', this.#timeout + 'ms');

		let noticesWrapper = document.querySelector('.levcharity-notification-wrapper');

		if (!noticesWrapper) {
			noticesWrapper = document.createElement('div');
			noticesWrapper.classList.add('levcharity-notification-wrapper');
			document.body.append(noticesWrapper);
		}

		noticesWrapper.append(notification);

		setTimeout(() => {
			notification.classList.add('show');

			setTimeout(() => {
				notification.classList.remove('show');
				setTimeout(() => {
					const nextEl = notification.nextElementSibling || null;
					if (nextEl) {
						nextEl.style.transition = '0s';
						nextEl.style.marginTop = notification.offsetHeight + 16 + 'px';
					}
					setTimeout(() => {
						if (nextEl) {
							nextEl.style.transition = '';
							nextEl.style.marginTop = '';
						}

						setTimeout(() => {

							if (!noticesWrapper.children.length) {
								noticesWrapper.remove();
							}
						}, 310)
					}, 10)



					notification.remove();
				}, 300)
			}, this.#timeout)
		}, 10)
	}
}
